import { OfferInfo, isOfferActive } from "@/utils/offerUtils";

interface SaleStickerProps {
  offer?: OfferInfo | null;
  isAr?: boolean;
  className?: string;
  size?: number;
}

/**
 * Circular "sale stamp" sticker.
 * Top line: SALE / خصم
 * Bottom line: value (e.g. "15%" or "20 EGP")
 */
const SaleSticker = ({ offer, isAr = false, className = "", size = 64 }: SaleStickerProps) => {
  if (!isOfferActive(offer)) return null;
  const o = offer!;
  const value = o.type === "percentage" ? `${o.value}%` : isAr ? `${o.value} ج` : `${o.value} EGP`;
  const top = isAr ? "خصم" : "SALE";

  return (
    <div
      className={`relative inline-flex items-center justify-center select-none pointer-events-none ${className}`}
      style={{ width: size, height: size }}
      aria-label={`${top} ${value}`}
    >
      {/* Scalloped outer ring */}
      <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full drop-shadow-[0_4px_10px_rgba(0,0,0,0.25)]" aria-hidden>
        <defs>
          <radialGradient id="saleFill" cx="50%" cy="40%" r="60%">
            <stop offset="0%" stopColor="hsl(0 75% 58%)" />
            <stop offset="100%" stopColor="hsl(0 70% 42%)" />
          </radialGradient>
        </defs>
        {(() => {
          const points = 16;
          const rOuter = 48;
          const rInner = 42;
          let d = "";
          for (let i = 0; i < points * 2; i++) {
            const angle = (i * Math.PI) / points;
            const r = i % 2 === 0 ? rOuter : rInner;
            const x = 50 + r * Math.cos(angle);
            const y = 50 + r * Math.sin(angle);
            d += `${i === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)} `;
          }
          return <path d={d + "Z"} fill="url(#saleFill)" />;
        })()}
        <circle cx="50" cy="50" r="36" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="0.8" strokeDasharray="2 2" />
      </svg>
      <div className="relative flex flex-col items-center justify-center text-white leading-none rotate-[-12deg]">
        <span
          className="font-serif uppercase tracking-widest"
          style={{ fontSize: size * 0.16 }}
        >
          {top}
        </span>
        <span className="font-serif font-bold" style={{ fontSize: size * 0.28, marginTop: size * 0.04 }}>
          {value}
        </span>
      </div>
    </div>
  );
};

export default SaleSticker;
